import React, { Component } from 'react';
import PropTypes from 'prop-types';

const fallbackContainerStyle = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  justifyContent: 'center',
  minHeight: '240px',
  padding: '48px 24px',
  textAlign: 'center',
};

const refreshButtonStyle = {
  background: '#1890ff',
  border: 0,
  borderRadius: '4px',
  color: '#fff',
  cursor: 'pointer',
  padding: '10px 16px',
};

export class ViewerLoadBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={fallbackContainerStyle}>
          <div>We couldn&apos;t load the viewer.</div>
          <button type="button" style={refreshButtonStyle} onClick={this.handleRefresh}>
            Refresh page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

ViewerLoadBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  resetKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

ViewerLoadBoundary.defaultProps = {
  resetKey: '',
};

export default ViewerLoadBoundary;
